<template>
  <div id="guide">
    <div class="guide-progress" v-if="!isMobile">
      <guide-progress
          :currentStep="steps[currentGuideStep]"
          :steps="steps"
          @stepBack="stepBack"
      ></guide-progress>
    </div>

    <div class="guide-step flexwrap">
      <keep-alive>
        <transition :name="!isMobile?'slide-fade':'slide-fade-left'" mode="out-in">
          <component :is="steps[currentGuideStep].component"
                     source="guide"
                     :guideTempProfile="tempProfile"
                     :connexion-type="0"
                     :showTitle="showTitle"
                     :displayMessage="!steps[currentGuideStep].checked"
                     @setShowTitle="setShowTitle"
                     @profileChanged="updateProfile"
          >
          </component>
        </transition>

      </keep-alive>
    </div>

    <div class="guide-progress" v-if="isMobile">
      <guide-progress
          :currentStep="steps[currentGuideStep]"
          :steps="steps"
          @stepBack="stepBack"
      ></guide-progress>
    </div>
  </div>
</template>

<script>
import {API_URL} from "@/App";
import axios from "axios";
import {mapGetters} from "vuex";

export default {
name: "guide",



  components: {
    GuideProgress: () => import(/* webpackPrefetch: true */ '@/components/guide-progress.vue'),
    UserLWContext: () => import(/* webpackPrefetch: true */ '@/components/userLWContext.vue'),
    UserVODServices: () => import(/* webpackPrefetch: true */ '@/components/userVODServices.vue'),
    MyLevel: () => import(/* webpackPrefetch: true */ '@/components/my-level.vue'),
    SelectNewShow: () => import(/* webpackPrefetch: true */ '@/components/selectNewShow.vue'),
    Goal: () => import(/* webpackPrefetch: true */ '@/components/setgoal.vue'),
    Login: () => import(/* webpackPrefetch: true */ '@/components/login.vue'),
  },

  created() {
  // On vérifie si le user (cookies) existe déjà
    // OUI : on fetch tempUser pour remplir tempProfile
    // NON : on génère un user qu'on stocke en cookies
    if(this.$cookies.isKey('user')) {
     this.tempProfile = this.$cookies.get('user')
      this.currentGuideStep = this.$cookies.get('guideStep')

      this.$session.set('user', this.tempProfile)
      this.$session.set('guideStep', this.currentGuideStep)
    }
    else if(this.$session.has('user')) {
      this.tempProfile = this.$session.get('user')
      this.currentGuideStep = this.$session.get('guideStep')
    }

    this.$router.replace({
      name: 'guide', params: {step: this.currentGuideStep}
    })

    for(let i=0; i< this.currentGuideStep; i++) {
      this.steps[i].checked = true
    }
  },

  computed: {
    ...mapGetters('global', [
      'isMobile',
        'routeParams'
    ]),
  },

  methods: {
    updateProfile: function(newProfile) {
      this.tempProfile = Object.assign(this.tempProfile, newProfile)
      this.$cookies.set('user', this.tempProfile);
      this.$session.set('user', this.tempProfile)

      // Si l'utilisateur a complété l'étape pour la première fois, on envoie l'évènement
      if(!this.steps[this.currentGuideStep].checked) {
        if(!this.$isDebug) {
          gtag('event', this.steps[this.currentGuideStep].name, {
            'event_category': 'Guide',
            'event_label': this.steps[this.currentGuideStep].name
          })

          fbq('track', this.steps[this.currentGuideStep].name);
        }
      }

      this.steps[this.currentGuideStep].checked = true

      this.currentGuideStep++

      this.$cookies.set('guideStep', this.currentGuideStep);
      this.$session.set('guideStep', this.currentGuideStep);
    },

    stepBack: function(stepIndex) {
      this.currentGuideStep = stepIndex;
    },

    setShowTitle(title) {
      this.showTitle = title    }
  },

  /*
  beforeRouteLeave(to, from) {
    if(this.currentGuideStep > 0) {
      this.currentGuideStep = 0
    }
    return false
  },*/

  watch: {
    'currentGuideStep': function() {
      this.$router.push({
        name: 'guide', params: {step: this.currentGuideStep}
      })
    },

    'routeParams': function() {
      this.currentGuideStep = this.routeParams.step
    }
  },

  data() {
    return {
      tempProfile: {
        english_for: '',
        how_discover: '',
        streaming_services: [],
        estimated_level: 2,
        current_season: -1,
        studying_friday: false,
        studying_monday: false,
        studying_saturday: false,
        studying_sunday: false,
        studying_thursday: false,
        studying_tuesday: false,
        studying_wednesday: false,
        reminders_ok: true
      },
      showTitle: '',
      currentGuideStep: 0,
      steps: [
        {
          name: 'user-vod',
          label: 'Services VOD',
          component: 'UserVODServices',
          checked: false
        },
        {
          name: 'level',
          label: 'Sélection d\'un niveau',
          component: 'MyLevel',
          checked: false
        },
        {
          name: 'serie',
          label: 'Choix d\'une série',
          component: 'SelectNewShow',
          checked: false
        },
        {
          name: 'goal',
          label: 'Choix d\'un objectif',
          component: 'Goal',
          checked: false
        },
        {
          name: 'login',
          label: 'Finalisation du profil',
          component: 'Login',
          checked: false
        },
      ],
    }
  }
}
</script>

<style scoped>
  #guide {
    box-sizing: border-box;
    position: relative;
    height: 100%;
    padding-top: 4vw;
    width: 100vw;
    display: flex;
    flex-direction: row;
    background-color: var(--goalBackgroundColor3);
  }

  .guide-progress {
    min-width: 23vw;
    max-width: 23vw;
    height: calc(100% - 6vw);
    background-color: var(--navBackgroundColor);
    align-self: center;
    border-radius: 0 2vw 2vw 0;
  }

  .guide-step {
    flex-grow: 1;
    height: calc(100% - 6vw);
    width: calc(100% - 6vw);
    justify-content: center;
    align-content: flex-start;
    margin: 3vw;
  }

  @media screen and (max-device-width: 767px) {

    #guide {
      box-sizing: border-box;
      position: relative;
      height: calc(var(--vh, 1vh) * 100);
      max-height: calc(var(--vh, 1vh) * 100);
      padding-top: 15vw;
      width: 100vw;
      display: flex;
      flex-direction: column;
      background-color: var(--goalBackgroundColor3);
    }

    .guide-step {
      flex-grow: 1;
      flex-shrink: 1;
      height: calc(100% - 6vh);
      width: 100%;
      margin: 0;
    }

    .guide-progress {
      min-width: 100vw;
      max-width: 100vw;
      height: 6vh;
      background-color: var(--navBackgroundColor);
      align-self: center;
      border-radius: 0 0 0 0;
    }
  }
</style>
